module.exports = __webpack_public_path__ + "static/media/school.58ad056d.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/about-us/img/school.png
// module id = 1718
// module chunks = 146